function generateShopAssociatedKey(shopId, key)
{
    return `${key}_${shopId}`;
}

export {
    generateShopAssociatedKey,
}